<template>
  <HeadlineComponent>Bestätige deine E-Mail</HeadlineComponent>
  <p>Einen moment bitte!</p>
</template>

<script>
import HeadlineComponent from "../components/HeadlineComponent.vue";
import userService from "../services/user.service.js";
import {mapActions, mapState} from "pinia";
import {useAlertsStore} from "../stores/alerts.js";
import { useUserStore } from "../stores/user.js";
import * as Sentry from '@sentry/vue';
export default {
  name: "ConfirmEmailView",
  components: {HeadlineComponent},
  methods: {
    ...mapActions(useAlertsStore, {addAlert: 'add'}),
    ...mapActions(useUserStore, ['confirmEmail']),
  },
  computed: {
    ...mapState(useUserStore, ['isLoggedin'])
  },
  async mounted() {
    try {
      let response = await userService.confirmEmail({
        email: this.$route.query.email,
        code: parseInt(this.$route.query.code)
      })
      this.addAlert('success', response.data.message)
      this.$router.push('/');
    } catch(e) {
      if (e) {
        Sentry.captureException(e);
        this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
      }
    }
  }
}
</script>

<style scoped>

</style>